import { render } from "./RecentlyViewed.vue?vue&type=template&id=1694e8c0&scoped=true"
import script from "./RecentlyViewed.vue?vue&type=script&lang=js"
export * from "./RecentlyViewed.vue?vue&type=script&lang=js"

import "./RecentlyViewed.vue?vue&type=style&index=0&id=1694e8c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1694e8c0"]])

export default __exports__